<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges && edit"></alert-unsaved-changes>
    <v-form>
      <v-row v-if="edit">
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <label>User manual</label>
                    <p class="label-info">
                      Upload pdf
                    </p>
                    <v-file-input
                      v-model="addUserManual"
                      outlined
                      :placeholder="'Upload pdf'"
                      clearable
                      prepend-icon=""
                    >
                    </v-file-input>
                    <div v-if="userManualFile">
                      <v-chip :close="true" @click:close="deleteUserManual">
                        {{ userManualFile }}
                      </v-chip>
                    </div>
                    <div align="center">
                      <v-btn
                        @click="uploadUserManual"
                        :disabled="!isUserManualFileSelected"
                        depressed
                        rounded
                        medium
                        color="primary200"
                        class="white--text font-weight-bold"
                        >Upload File
                        <v-icon color="white">mdi-upload</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <label>Terms of use</label>
                    <p class="label-info">
                      Upload pdf
                    </p>
                    <v-file-input
                      v-model="addTermsOfUse"
                      outlined
                      :placeholder="'Upload pdf'"
                      clearable
                      prepend-icon=""
                    >
                    </v-file-input>
                    <div v-if="termsOfUseFile">
                      <v-chip :close="true" @click:close="deleteTermsOfUse">
                        {{ termsOfUseFile }}
                      </v-chip>
                    </div>
                    <div align="center">
                      <v-btn
                        @click="uploadTermsOfUse"
                        :disabled="!isTermsOfUseFileSelected"
                        depressed
                        rounded
                        medium
                        color="primary200"
                        class="white--text font-weight-bold"
                        >Upload File
                        <v-icon color="white">mdi-upload</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <label>Standards</label>
                    <p class="label-info">List of standards supported by the Equipment.</p>
                    <v-combobox
                      v-model="standards"
                      clearable
                      :placeholder="'Standards'"
                      multiple
                      small-chips
                      return-object
                      outlined
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Type and press <span class="text-bold">enter</span> to create a new
                              standard
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ attrs, item, parent, selected }">
                        <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          :close="true"
                          @click:close="removeChip(item)"
                        >
                          <span class="pr-2">
                            {{ item }}
                          </span>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Buttons -->
      <v-row class="my-5" justify="end">
        <v-btn
          v-if="unsavedChanges && edit"
          @click="cancel"
          outlined
          class="black--text font-weight-bold mx-2"
          rounded
          x-large
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          v-if="unsavedChanges && edit"
          @click="updateEquipmentAdditionalInfo"
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
        >
          {{ $t('update') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="black"
          @click="back"
          outlined
          class="black--text font-weight-bold mx-2"
        >
          <v-icon color="black">$vuetify.icons.back</v-icon>
          {{ $t('back') }}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';

export default {
  name: 'EquipmentAdditionalInfo',
  mixins: [util],
  components: { AlertUnsavedChanges },
  data: () => ({
    addUserManual: null,
    addTermsOfUse: null,
    standards: [],
    unsavedChanges: false,
    dataLoaded: false,
    initialStandards: {},
    status: false,
    initialStatus: {},
    userManualFile: null,
    termsOfUseFile: null,
    isUserManualFileSelected: false,
    isTermsOfUseFileSelected: false,
  }),
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    published: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    standards: {
      deep: true,
      handler(newStandard) {
        if (!this.dataLoaded) return;

        if (JSON.stringify(newStandard) !== JSON.stringify(this.initialStandards)) {
          this.unsavedChanges = true;
        } else {
          this.unsavedChanges = false;
        }
      },
    },
    published: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges = this.status !== this.published;
      },
    },
    addUserManual(newVal) {
      this.isUserManualFileSelected = newVal !== null;
    },
    addTermsOfUse(newVal) {
      this.isTermsOfUseFileSelected = newVal !== null;
    },
  },
  mounted() {
    if (this.edit) {
      this.getEquipmentIdAdditionalInfo();
    }
  },
  methods: {
    back() {
      this.$emit('tab', 5);
    },
    removeChip(itemText) {
      this.standards.forEach(obj => {
        if (obj === itemText) {
          this.standards.splice(this.standards.indexOf(obj), 1);
        }
      });
      this.standards = [...this.standards];
    },
    getEquipmentIdAdditionalInfo() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/equipment/${id}`)
        .then(response => {
          console.log('Get Equipment Additional Info', response.data);

          this.status = response.data.published;

          this.initialStatus = {
            published: response.data.published,
          };
          this.$emit('status', this.initialStatus.published);

          if (response.data.standards) {
            this.standards = response.data.standards;

            this.initialStandards = JSON.parse(JSON.stringify(this.standards));
          }

          if (response.data.userManual) {
            this.userManualFile = response.data.userManual;
          }

          if (response.data.termsOfUse) {
            this.termsOfUseFile = response.data.termsOfUse;
          }

          this.dataLoaded = true;
        })
        .catch(error => {
          console.error('Error fetching equipment data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    updateEquipmentAdditionalInfo() {
      const id = this.$route.params.id;

      const standards = this.standards.map(standard => standard);
      const equipmentUpdateData = {
        published: this.published,
        id: id,
        standards: standards,
      };

      this.axios
        .put('api/v1/equipment/additional-info', equipmentUpdateData)
        .then(response => {
          console.log('Equipment info updated successfully:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Equipment Updated Successfully',
          });

          this.initialStatus = this.status;
          this.unsavedChanges = false;
          this.$emit('updatedChanges', true);

          this.getEquipmentIdAdditionalInfo();
        })
        .catch(error => {
          console.error('Error updating equipment info:', error);
        });
    },
    cancel() {
      this.getEquipmentIdAdditionalInfo();
    },
    uploadTermsOfUse() {
      const id = this.$route.params.id;

      if (this.addTermsOfUse) {
        const fileType = this.addTermsOfUse.type;
        if (fileType !== 'application/pdf') {
          EventBus.$emit('snackbar', {
            text: 'Only PDF files are allowed!',
          });
          return;
        }

        const formData = new FormData();
        formData.append('type', this.addTermsOfUse.type);
        formData.append('name', this.addTermsOfUse.name);
        formData.append('size', this.addTermsOfUse.size);
        formData.append('file', this.addTermsOfUse);

        this.axios
          .put(`api/v1/equipment/${id}/file?field=termsOfUse`, formData)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File uploaded successfully!',
            });
            this.getEquipmentIdAdditionalInfo();
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to upload file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    uploadUserManual() {
      const id = this.$route.params.id;

      if (this.addUserManual) {
        const fileType = this.addUserManual.type;
        if (fileType !== 'application/pdf') {
          EventBus.$emit('snackbar', {
            text: 'Only PDF files are allowed!',
          });
          return;
        }

        const formData = new FormData();
        formData.append('type', this.addUserManual.type);
        formData.append('name', this.addUserManual.name);
        formData.append('size', this.addUserManual.size);
        formData.append('file', this.addUserManual);

        this.axios
          .put(`api/v1/equipment/${id}/file?field=userManual`, formData)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File uploaded successfully!',
            });
            this.getEquipmentIdAdditionalInfo();
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to upload file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    deleteUserManual() {
      const id = this.$route.params.id;

      if (this.userManualFile) {
        const fileName = this.userManualFile.name;

        this.axios
          .put(`api/v1/equipment/${id}/file/${fileName}?field=userManual`)
          .then(response => {
            console.log('User manual deleted successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'User manual deleted successfully!',
            });
            this.userManualFile = null;
            this.addUserManual = null;
          })
          .catch(error => {
            console.error('Error deleting user manual:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to delete user manual. Please try again.',
            });
          });
      } else {
        console.log('No user manual file to delete.');
      }
    },
    deleteTermsOfUse() {
      const id = this.$route.params.id;

      if (this.termsOfUseFile) {
        const fileName = this.termsOfUseFile.name;

        this.axios
          .put(`api/v1/equipment/${id}/file/${fileName}?field=termsOfUse`)
          .then(response => {
            console.log('Terms of Use deleted successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'Terms of Use deleted successfully!',
            });
            this.termsOfUseFile = null;
            this.addTermsOfUse = null;
          })
          .catch(error => {
            console.error('Error deleting terms of use:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to delete terms of use. Please try again.',
            });
          });
      } else {
        console.log('No terms of use file to delete.');
      }
    },
  },
};
</script>
